var _circle, _path, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg3 = function Svg3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 16,
    r: 14,
    fill: "url(#paint0_linear_692_423040)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3767 26H10.2885C8.92181 25.999 7.60852 25.4779 6.62355 24.5459C5.63858 23.6138 5.05829 22.3431 5.00416 20.9996C4.95003 19.6562 5.42626 18.3443 6.33315 17.3385C7.24004 16.3326 8.50728 15.7109 9.86958 15.6035C10.0639 14.254 10.6833 12.9983 11.6408 12.0132C12.5983 11.0281 13.8457 10.3631 15.2074 10.1118C16.5691 9.86043 17.9767 10.0354 19.232 10.6121C20.4874 11.1887 21.5274 12.1381 22.2057 13.3266C23.4498 12.9029 24.7939 12.8534 26.0668 13.1843C27.3396 13.5153 28.4833 14.2117 29.3521 15.1848C30.2209 16.1579 30.7754 17.3635 30.9449 18.6479C31.1143 19.9323 30.891 21.2372 30.3035 22.3962C29.9587 23.4434 29.2856 24.3563 28.3807 25.0037C27.4757 25.6512 26.3856 26 25.2666 26H24.3767Z",
    fill: "url(#paint1_linear_692_423040)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_692_423040",
    x1: 4.5,
    y1: 4.625,
    x2: 26.1562,
    y2: 26.2813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAE359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEB41C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_692_423040",
    x1: 9.56282,
    y1: 11.3394,
    x2: 25.3799,
    y2: 27.4175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDCFE1"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/3.99cb89ec.svg";
export { ForwardRef as ReactComponent };